/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Api_Errors_Vakantie_Not_FoundInputs */

const nl_planning_api_errors_vakantie_not_found = /** @type {(inputs: Planning_Api_Errors_Vakantie_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze vakantie staat niet (meer) in het advies voor jullie regio.`)
};

/**

* @param {Planning_Api_Errors_Vakantie_Not_FoundInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_api_errors_vakantie_not_found = /** @type {((inputs?: Planning_Api_Errors_Vakantie_Not_FoundInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Api_Errors_Vakantie_Not_FoundInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_api_errors_vakantie_not_found(inputs)
});
export { planning_api_errors_vakantie_not_found as "planning.api_errors.vakantie_not_found" }